import { css } from 'styled-components'

export const limitLines = (lines: number) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const skeletonAnimation = css`
  background: var(--gray-100);
  background-image: linear-gradient(
    to right,
    var(--gray-100) 0%,
    var(--gray-200) 20%,
    var(--gray-100) 40%,
    var(--gray-100) 100%
  );
  background-size: 80rem 14rem;
  animation: placeholderShimmer 1s linear infinite forwards;

  @keyframes placeholderShimmer {
    0% {
      background-position: -40rem 0;
    }
    100% {
      background-position: 40rem 0;
    }
  }
`
